import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss/lib/injectSheet';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { departmentFilterChangedCreator } from '../../actions';
import { greenhouseFilters } from '../../selectors';
import styles from './styles';

const Departments = ({
  greenhouse,
  filters,
  onDepartmentChange,
  classes,
}) => {
  const options = [];

  greenhouse.departments.value.forEach(department => {
    options.push((
      <option value={department.id} key={department.id}>
        {department.name}
      </option>
    ));

    department.children.forEach(child => {
      options.push(
        <option value={child.id} key={child.id}>
          &nbsp;&nbsp; {child.name}
        </option>,
      );
    });
  });

  return (
    <select
      className={classes.customSelect}
      value={filters.departmentId}
      onChange={e => onDepartmentChange(e.target.value)}
    >
      <option value>
        All Departments
      </option>
      { options }
    </select>
  );
};

Departments.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  filters: PropTypes.shape({
    departmentId: PropTypes.number.isRequired,
  }).isRequired,
  greenhouse: PropTypes.shape({
    departments: PropTypes.shape({
      busy: PropTypes.bool.isRequired,
      error: PropTypes.bool,
      value: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        jobs: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number.isRequired,
            title: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            location: PropTypes.string.isRequired,
          }),
        ),
        children: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          jobs: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.number.isRequired,
              title: PropTypes.string.isRequired,
              url: PropTypes.string.isRequired,
              location: PropTypes.string.isRequired,
            }),
          ),
        })),
      })).isRequired,
    }),
  }).isRequired,
  onDepartmentChange: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  ...state,
  filters: greenhouseFilters(state),
});

const mapDispatchToProps = dispatch => ({
  onDepartmentChange: departmentId => dispatch(
    departmentFilterChangedCreator(Number(departmentId)),
  ),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectSheet({
    ...styles,
  }),
)(Departments);
